import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Usuario } from '../../login/usuario';
import { AuthService } from '../../../core/services/auth.service';

@Component({
  selector: 'app-treino-modal',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './treino-modal.component.html'
})
export class TreinoModalComponent {

  form!: FormGroup;

  @Input() data: any;
  @Output() salvar = new EventEmitter<any>();

  user: Usuario | null = null;

  constructor(
    private authorizeService: AuthService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit() {
    this.user = this.authorizeService.getUser();

    this.form = this.fb.group({
      id: [this.data?.id || 0],
      nome: [this.data?.nome || '', Validators.required],
      diaSemana: [this.data?.diaSemana || 1],
      usuarioId: [this.user?.id]
    });
  }

  submit() {
    if (this.form.valid) {
      console.log("treinoPreenchido",this.form.value)
      this.salvar.emit(this.form.value);
      this.activeModal.close();
    }
  }
  
}
